// extracted by mini-css-extract-plugin
export default {"timeSpan":"fPtoJR2jdG","icon":"l_QMREN0IL","icon_inList":"Ja6reOehLG"};